import React from 'react';
import {Styles} from '../../../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {connect, setStore} from "trim-redux";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import withWidth from "@material-ui/core/withWidth/withWidth";
import Grid from "@material-ui/core/Grid/Grid";
import {Translate} from "../../../../../../config/Translate";
import TextField from "@material-ui/core/TextField/TextField";
import axios from "axios";
import {defaultVariabls} from "../../../../../../config";
import LoadingButton from "../../../../../components/elements/LoadingButton";
import SaveRoundedIcon from '@material-ui/icons/SaveRounded';
import {LoadSetting} from "../../../../../../config/Security";
import AppCardLoaderFields from "../../../../../components/Skeletons/AppCardLoaderFields";
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";
import FieldCounterWithoutBar from "../../../../../components/elements/FieldCounterWithoutBar";

class ManageCommissions extends React.Component {
    classes = this.props.classes;
    state = {
        fields:{
            new_normal:'',
            new_virtual:'',
            new_physical:'',
            new_publisher:'',
            new_distribution:'',
            worked_normal:'',
            worked_virtual:'',
            worked_physical:'',
            worked_publisher:'',
            worked_distribution:'',
        },
        SubmitLoading:false,
        loading:true,
        errors:{}
    };
    componentDidMount() {
        this.loadData();
    }
    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/commissions/getAll`, config)
                .then(response => {
                    this.setState({
                        fields:{
                            new_normal:response.data.new_normal,
                            new_virtual:response.data.new_virtual,
                            new_physical:response.data.new_physical,
                            new_publisher:response.data.new_publisher,
                            new_distribution:response.data.new_distribution,
                            worked_normal:response.data.worked_normal,
                            worked_virtual:response.data.worked_virtual,
                            worked_physical:response.data.worked_physical,
                            worked_publisher:response.data.worked_publisher,
                            worked_distribution:response.data.worked_distribution,
                        },
                        loading:false,
                    })
                }).catch(error => {

                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
            this.setState({
                loading:false
            })
        }
    }

    handleChange(e){
        let {errors,fields} = this.state;
        let target = e.target;
        fields[target.name] = target.value;
        errors[target.name] = "";
        this.setState({fields});
    }

    handleValidation(callback){
        let { fields } = this.state;
        let errors = {};
        let formIsValid = true;



        if(!formIsValid){
            this.props.enqueueSnackbar(Translate.someFieldsHasError, {
                variant: 'warning',
            });
            this.setState({
                errors,
                SubmitLoading:false,
            })
        }
        return callback(formIsValid)
    }

    handleRequest(){
        let { fields} = this.state;
        let data = new FormData();
        data.append('new_normal', fields.new_normal);
        data.append('new_virtual', fields.new_virtual);
        data.append('new_physical', fields.new_physical);
        data.append('new_publisher', fields.new_publisher);
        data.append('new_distribution', fields.new_distribution);
        data.append('worked_normal', fields.worked_normal);
        data.append('worked_virtual', fields.worked_virtual);
        data.append('worked_physical', fields.worked_physical);
        data.append('worked_publisher', fields.worked_publisher);
        data.append('worked_distribution', fields.worked_distribution);

        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/commissions/save`, data, config)
            .then(async response => {
                await LoadSetting();
                await this.setState({
                    loading:false,
                    SubmitLoading: false,
                });
                await this.props.enqueueSnackbar(Translate.allChangesSaved, {
                    variant: 'success',
                });
            })
            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(Translate.allChangesSavingFailed, {
                    variant: 'error',
                });
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                });
            });

    }
    handleSubmit(e){
        this.setState({
            SubmitLoading: true
        })
        e.preventDefault();
        this.handleValidation((valid) =>{
            if(valid) {
                this.handleRequest();
            }
        });
    }
    render(){
        let {errors,fields,SubmitLoading,loading} = this.state;
        return (
            <>
                {
                    loading ?
                        <AppCardLoaderFields/> :
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    variant="outlined"
                                    value={fields.new_normal}
                                    fullWidth
                                    size="small"
                                    type="number"
                                    label={Translate.new_normal}
                                    name="new_normal"
                                    onChange={this.handleChange.bind(this)}
                                    error = {!!errors['new_normal']}
                                    helperText={errors['new_normal']}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                %
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    variant="outlined"
                                    value={fields.new_virtual}
                                    fullWidth
                                    size="small"
                                    type="number"
                                    label={Translate.new_virtual}
                                    name="new_virtual"
                                    onChange={this.handleChange.bind(this)}
                                    error = {!!errors['new_virtual']}
                                    helperText={errors['new_virtual']}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                %
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    variant="outlined"
                                    value={fields.new_physical}
                                    fullWidth
                                    size="small"
                                    type="number"
                                    label={Translate.new_physical}
                                    name="new_physical"
                                    onChange={this.handleChange.bind(this)}
                                    error = {!!errors['new_physical']}
                                    helperText={errors['new_physical']}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                %
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    variant="outlined"
                                    value={fields.new_publisher}
                                    fullWidth
                                    size="small"
                                    type="number"
                                    label={Translate.new_publisher}
                                    name="new_publisher"
                                    onChange={this.handleChange.bind(this)}
                                    error = {!!errors['new_publisher']}
                                    helperText={errors['new_publisher']}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                %
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    variant="outlined"
                                    value={fields.new_distribution}
                                    fullWidth
                                    size="small"
                                    type="number"
                                    label={Translate.new_distribution}
                                    name="new_distribution"
                                    onChange={this.handleChange.bind(this)}
                                    error = {!!errors['new_distribution']}
                                    helperText={errors['new_distribution']}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                %
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    variant="outlined"
                                    value={fields.worked_normal}
                                    fullWidth
                                    size="small"
                                    type="number"
                                    label={Translate.worked_normal}
                                    name="worked_normal"
                                    onChange={this.handleChange.bind(this)}
                                    error = {!!errors['worked_normal']}
                                    helperText={errors['worked_normal']}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                %
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    variant="outlined"
                                    value={fields.worked_virtual}
                                    fullWidth
                                    size="small"
                                    type="number"
                                    label={Translate.worked_virtual}
                                    name="worked_virtual"
                                    onChange={this.handleChange.bind(this)}
                                    error = {!!errors['worked_virtual']}
                                    helperText={errors['worked_virtual']}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                %
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    variant="outlined"
                                    value={fields.worked_physical}
                                    fullWidth
                                    size="small"
                                    type="number"
                                    label={Translate.worked_physical}
                                    name="worked_physical"
                                    onChange={this.handleChange.bind(this)}
                                    error = {!!errors['worked_physical']}
                                    helperText={errors['worked_physical']}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                %
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    variant="outlined"
                                    value={fields.worked_publisher}
                                    fullWidth
                                    size="small"
                                    type="number"
                                    label={Translate.worked_publisher}
                                    name="worked_publisher"
                                    onChange={this.handleChange.bind(this)}
                                    error = {!!errors['worked_publisher']}
                                    helperText={errors['worked_publisher']}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                %
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    variant="outlined"
                                    value={fields.worked_distribution}
                                    fullWidth
                                    size="small"
                                    type="number"
                                    label={Translate.worked_distribution}
                                    name="worked_distribution"
                                    onChange={this.handleChange.bind(this)}
                                    error = {!!errors['worked_distribution']}
                                    helperText={errors['worked_distribution']}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                %
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <LoadingButton
                                    variant="contained"
                                    color="primary"
                                    startIcon={<SaveRoundedIcon/>}
                                    onClick={this.handleSubmit.bind(this)}
                                    loading={SubmitLoading}
                                >
                                    {Translate.saveChanges}
                                </LoadingButton>
                            </Grid>
                        </Grid>
                }
            </>
        );
    }
}

const mstp = state => ({
    locale: state.locale,
    about: state.about,
    setting: state.setting,
});
export default withWidth()(withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(ManageCommissions)))));